module.exports = __webpack_public_path__ + "files/6f535ccd80e82e6154348728e0c80e0d.png";